import ContestWinnerManagementModule from '@/modules/contest-winner-management';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  id: z.coerce.string().optional(),
});

export const Route = createFileRoute(
  '/dashboard/fantasy/fixture/contest-winner-management/'
)({
  validateSearch: searchSchema,
  component: ContestWinnerManagementPage,
});

function ContestWinnerManagementPage() {
  return <ContestWinnerManagementModule />;
}
